module.exports = __webpack_public_path__ + "img/hero-h.d8ffab9f.png";